'use client';
import { useMemo } from 'react';
import { Dropdown } from '@/shared/ui/Dropdown/Dropdown';
import { Portal } from '@/shared/ui/Portal';
import { twMergeExt } from '@/shared/utils/twMergeExt';
import SortMobilePopup from '@/widgets/SortMobilePopup/ui/SortMobilePopup';
import { cva } from 'class-variance-authority';
import { AnimatePresence } from 'framer-motion';
import { FC, useState } from 'react';
import IconSort from '/public/icons/sort.svg';

interface Props {
  className?: string;
  fieldProps?: any;
  onChange?: (value: any) => void;
}

const DATA_SORTING_LIST = [
  {
    id: 0,
    value: 'popular',
    label: 'По популярности',
  },
  {
    id: 1,
    value: 'price',
    label: 'Сначала недорогие',
  },
  {
    id: 2,
    value: '-price',
    label: 'Сначала дорогие',
  },
];

export const CatalogCategorySorts: FC<Props> = ({ className, fieldProps, onChange }) => {
  const [showMobileSort, setShowMobileSort] = useState(false);

  const handleClickMobileSort = () => {
    setShowMobileSort(!showMobileSort);
  };

  const activeSort = useMemo(() => fieldProps('sort'), [fieldProps]);
  const activeSortLabel = useMemo(
    () => DATA_SORTING_LIST.find(({ value }) => value === activeSort.value)?.label,
    [activeSort]
  );

  return (
    <div className={twMergeExt(cvaRoot(), className)}>
      <Dropdown
        name={'sort'}
        onChange={onChange}
        data={DATA_SORTING_LIST}
        value={activeSort.value}
        placeholder={'Сортировка'}
        place={'right'}
        multiselect={false}
        className={cvaSortDropdown()}
        // selectedSlot={() => activeSort}
      />
      <div className={cvaSortMobile()} onClick={() => handleClickMobileSort()}>
        <IconSort className={cvaSortMobileIcon()} />
        {activeSortLabel}
      </div>
      <AnimatePresence>
        {showMobileSort ? (
          <Portal>
            <SortMobilePopup
              data={DATA_SORTING_LIST}
              onChange={onChange}
              activeValue={activeSort.value}
              onClose={() => setShowMobileSort(false)}
            />
          </Portal>
        ) : null}
      </AnimatePresence>
    </div>
  );
};

const cvaRoot = cva(['CatalogCategorySorts-cvaRoot', 'text-bodyM']);

const cvaSortDropdown = cva(['CatalogCategorySorts-cvaSortDropdown', 'hidden md:block']);

const cvaSortMobile = cva([
  'CatalogCategorySorts-cvaSortMobile',
  'md:hidden',
  'relative',
  'pt-0.9 pb-1 pr-2.1 md:pr-0 md:pt-0 md:pb-0 pl-2.4',
  'text-bodyM',
  'cursor-pointer select-none',
]);

export const cvaSortMobileIcon = cva([
  'CatalogCategorySorts-cvaSortMobileIcon',
  'absolute left-0 top-1/2 -translate-y-1/2',
  'w-1.6 h-1.7',
  'fill-cBlack',
]);
